module.exports = __webpack_public_path__ + "static/everything-is-connected_acrylic-on-canvas-16x20in-2016-d7ed02724acf591cd81193eb275addc8.jpg";